import { render, staticRenderFns } from "./settingGoodsDialog.vue?vue&type=template&id=adbac222"
import script from "./settingGoodsDialog.vue?vue&type=script&lang=js"
export * from "./settingGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./settingGoodsDialog.vue?vue&type=style&index=0&id=adbac222&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adbac222')) {
      api.createRecord('adbac222', component.options)
    } else {
      api.reload('adbac222', component.options)
    }
    module.hot.accept("./settingGoodsDialog.vue?vue&type=template&id=adbac222", function () {
      api.rerender('adbac222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/goodsManage/components/settingGoodsDialog.vue"
export default component.exports